<script setup>
import { useFieldsStore } from "@/stores/storeFieldData";
import { useServiceStore } from "@/stores/serviceStore";
import { useValidation } from "@/utils/useValidataion";

const storeField = useFieldsStore();
const storeService = useServiceStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value);

const props = defineProps({
	timeList: {
		type: Array,
	},
	courtId: {
		type: String,
	}
});

function formatTimeRange(dateTimeStr) {
	
	const timePart = dateTimeStr.split("T")[1].split(":"); // ["19", "00", "00+03:00"]
	let hour = parseInt(timePart[0], 10);
	const minute = timePart[1];

	const start = `${String(hour).padStart(2, "0")}:${minute}`;

	let endHour = (hour + 1) % 24;
	const end = `${String(endHour).padStart(2, "0")}:${minute}`;

	return `${start} - ${end}`;
}
// rentalType = "court", rentalAt, price, crmId, title = '', desc = ''
</script>
<template>
	<label class="select-time" v-for="time of props.timeList" :key="time.price">
		<input 
			type="checkbox" 
			:checked="storeService.courtTimes.some(item => item.rental_at === time.date_time)" 
			class="select-time__real" 
			@change="storeService.addCourtTime('court', time.date_time, time.price, props.courtId, title = '', desc = '')" 
		/>
		<div class="select-time__custom">
			<div class="select-time__inner-time">
				<span class="select-time__check"></span>
				<span class="select-time__time">{{ formatTimeRange(time.date_time) }}</span>
			</div>
			<span class="select-time__price">{{ time.price }} p</span>
		</div>
	</label>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.select-time {
}
.select-time__real {
	width: 0;
	height: 0;
	opacity: 0;
	position: absolute;
	z-index: -1;
	&:checked {
		+ .select-time__custom {
			.select-time__check {
				background: var(--fill-inverse-1);
				&::before {
					transform: scale(1);
				}
			}
		}
	}
}
.select-time__custom {
	border: 1px solid var(--border-default-1);
	padding: 2rem;
	display: flex;
	align-items: center;
	justify-content: space-between;

	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
	color: var(--text-inverse-100);
	@media (max-width: vars.$x480) {
		padding: 0.8rem;
		font-size: 1.6rem;
	}
}
.select-time__inner-time {
	display: flex;
	align-items: center;
	gap: 1.6rem;
}
.select-time__check {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid var(--border-default-3);
	width: 2.4rem;
	height: 2.4rem;
	flex-shrink: 0;
	transition: background var(--transition) ease-in;
	@media (max-width: vars.$x480) {
		width: 2rem;
		height: 2rem;
	}

	&::before {
		content: "";
		display: inline-block;
		width: 2rem;
		height: 2rem;
		background-image: url("@/assets/img/icons/check_dark.svg");
		background-repeat: no-repeat;
		background-position: center;
		background-size: auto;
		position: absolute;
		transform: scale(0);
		transition: 0.2s ease-in;
		@media (max-width: vars.$x480) {
			width: 2rem;
			height: 2rem;
		}
	}
}
.select-time__time {
}
.v-enter-active,
.v-leave-active {
	transition: all 0.25s ease-out;
}

.v-enter-from {
	opacity: 0;
	transform: translateX(20px);
}
.v-leave-to {
	opacity: 0;
	transform: translateX(-20px);
}
</style>
